<button [type]="type" [class]="cssClass" [disabled]="disabled" data-testid="order-input-button">
  <span class="button--text" (click)="onButtonClick($event)">
    <img *ngIf="loading; else content" class="h-5 inline" src="/resources/small-spinner.gif" alt="" />
    <ng-template #content>
      <ng-content></ng-content>
    </ng-template>
  </span>
</button>
